import { Fragment } from "react";
import { func, object, string } from "prop-types";
import { BreakdownColumns, TaskTypes, DescriptionModes } from "@repo/utils";
import {
  TaskDescriptionCell,
  TaskLabelsCell,
  TaskPriceCell,
  TaskTitleCell,
  TaskEstimatesCell,
  TaskMaterialCell,
  TaskEstimatePlaceholdersCell,
} from "./cells";
import { observer } from "mobx-react";
import { useEstimateStructure, useEstimateTableSettings } from "@tools";

export const ColumnFactory = observer(({
  handleDescriptionEdition,
  confirmDescriptionEdition,
  children,
  parentName,
  ...cellProps
}) => {
  const structure = useEstimateStructure();
  const { lastPinnedCellLeft, displayColumns } = useEstimateTableSettings();
  
  const { showBreakdownColumns, descriptionMode } = structure.settings;
  
  return <>
    {
      displayColumns.map((column, index, columns) => {
        const props = {
          ...cellProps,
          isLastPinnedCell: lastPinnedCellLeft === column.id,
          isLastPinnableCell: !columns[index+1] || (columns[index+1].isVisible && !columns[index+1].pinnable),
          extendPadding: index === columns.length-1,
          colName: column.name,
          columnSettings: column,
        };
        
        switch (column.name) {
          case BreakdownColumns.TITLE:
            return <TaskTitleCell
              key={column.id}
              handleDescriptionEdition={handleDescriptionEdition}
              parentName={parentName}
              {...props}
            >
              { children }
            </TaskTitleCell>;
          
          case BreakdownColumns.LABELS:
            return <TaskLabelsCell
              key={column.id}
              {...props}
            />;
          
          case BreakdownColumns.DESCRIPTION:
            if(descriptionMode !== DescriptionModes.COLUMN)
              return <></>;
            return <TaskDescriptionCell
              key={column.id}
              onAfterChange={confirmDescriptionEdition}
              {...props}
            />;
          
          case BreakdownColumns.ESTIMATES:
            if(!showBreakdownColumns)
              return null;
            
            if(props.element.type === TaskTypes.FIXED_PRICE)
              return <TaskEstimatePlaceholdersCell
                key={column.id}
              />;
            
            if(props.element.type === TaskTypes.MATERIAL)
              return <TaskMaterialCell
                key={column.id}
                {...props}
              />;
            
            return <TaskEstimatesCell
              key={column.id}
              {...props}
            />;
            
          case BreakdownColumns.PRICE:
            return <TaskPriceCell
              key={column.id}
              {...props}
            />;
        }
    })
    }
  </>
  
})

ColumnFactory.propTypes = {
  element: object.isRequired,
  handleDescriptionEdition: func.isRequired,
  confirmDescriptionEdition: func.isRequired,
  parentName: string,
};
